import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const GlitchIntro = () => {
  const [complete, setComplete] = useState(false);
  const [text, setText] = useState("INITIALIZING...");

  useEffect(() => {
    // Sequence of hacking text
    const seq = [
      { t: 100, msg: "ESTABLISHING CONNECTION..." },
      { t: 400, msg: "BYPASSING FIREWALL [NODE 4]..." },
      { t: 800, msg: "DECRYPTING SUJAL_JAIN.DOSSIER..." },
      { t: 1300, msg: "ACCESS GRANTED." },
    ];

    seq.forEach(({ t, msg }) => {
      setTimeout(() => setText(msg), t);
    });

    const timer = setTimeout(() => {
      setComplete(true);
    }, 1800);

    return () => clearTimeout(timer);
  }, []);

  if (complete) return null;

  return (
    <Box sx={{
      position: "fixed", inset: 0, zIndex: 999999,
      bgcolor: "#000000", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      animation: "fadeOut 0.2s ease forwards",
      animationDelay: "1.6s",
    }}>
      <style>{`
        @keyframes fadeOut { to { opacity: 0; visibility: hidden; } }
      `}</style>
      <Box className="sys-glitch">
        <Typography sx={{ 
          fontFamily: "'JetBrains Mono', monospace", color: "#00f0ff", 
          fontSize: { xs: "0.8rem", md: "1.2rem" }, letterSpacing: "0.2em",
          textShadow: "0 0 15px rgba(0,240,255,0.6)"
        }}>
          {text}
        </Typography>
      </Box>
      <Box sx={{ width: "200px", height: "2px", bgcolor: "rgba(0,240,255,0.2)", mt: 4, position: "relative", overflow: "hidden" }}>
        <Box sx={{ 
          position: "absolute", left: 0, top: 0, height: "100%", bgcolor: "#00f0ff",
          animation: "loadBar 1.5s ease-out forwards"
        }} />
      </Box>
      <style>{`
        @keyframes loadBar { 
          0% { width: 0%; }
          30% { width: 45%; }
          60% { width: 60%; }
          100% { width: 100%; }
        }
      `}</style>
    </Box>
  );
};

export default GlitchIntro;
